import { createClient } from '@supabase/supabase-js';
import { isMockAuthEnabled, loadMockSession } from './utils/mockAuth';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Supabase configuration is missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your environment.'
  );
}

const authStorage = typeof window === 'undefined' ? undefined : window.localStorage;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: authStorage
  }
});

export const getAccessToken = async (): Promise<string> => {
  // Return mock token if mock auth is enabled
  if (isMockAuthEnabled()) {
    const mockSession = loadMockSession();
    if (mockSession?.access_token) {
      return mockSession.access_token;
    }
    throw new Error('No active mock session. Please sign in again.');
  }
  
  const {
    data: { session },
    error
  } = await supabase.auth.getSession();

  if (error) {
    throw error;
  }

  const token = session?.access_token;

  if (!token) {
    throw new Error('No active Supabase session. Please sign in again.');
  }

  return token;
};
